/**
 * Diagram editor — rotate helpers.
 * Node.rotation is around the local origin (top-left). These helpers keep the
 * visual center fixed when the angle changes so symbols spin in place.
 */
export function normalizeDegrees(deg) {
    var d = deg % 360;
    if (d > 180)
        d -= 360;
    if (d <= -180)
        d += 360;
    return d;
}
export function snapDegrees(deg, step) {
    if (step === void 0) { step = 15; }
    if (step <= 0)
        return normalizeDegrees(deg);
    return normalizeDegrees(Math.round(deg / step) * step);
}
/** Angle in degrees from center to pointer (0° = east, 90° = south — canvas Y-down). */
export function pointerAngleDegrees(cx, cy, px, py) {
    return (Math.atan2(py - cy, px - cx) * 180) / Math.PI;
}
/** Parent-space center of a card given top-left origin + rotation (degrees). */
export function rotatedCardCenter(x, y, width, height, rotationDeg) {
    var rad = (rotationDeg * Math.PI) / 180;
    var lx = width / 2;
    var ly = height / 2;
    var cos = Math.cos(rad);
    var sin = Math.sin(rad);
    return {
        x: x + lx * cos - ly * sin,
        y: y + lx * sin + ly * cos,
    };
}
/**
 * Set node.rotation while keeping the card's visual center fixed.
 * `width` / `height` are the unrotated card size including current scale.
 */
export function setRotationAroundCenter(node, nextDeg, width, height) {
    var _a;
    var w = Math.max(1, width);
    var h = Math.max(1, height);
    var before = rotatedCardCenter(node.x, node.y, w, h, node.rotation);
    node.rotation = normalizeDegrees(nextDeg);
    var after = rotatedCardCenter(node.x, node.y, w, h, node.rotation);
    node.x += before.x - after.x;
    node.y += before.y - after.y;
    (_a = node.markDirty) === null || _a === void 0 ? void 0 : _a.call(node);
}
